export default __webpack_public_path__ + "static/O0063-48ead71ad698b0bcec2046874ec580c3.png";